module.exports = ".amount-value {\n  font-weight: bold; }\n"